export const WELLBEING_STORAGE_KEY = 'mypeegu_wellbeing_v1'
export const RISK_SESSION_KEY = 'mypeegu_last_risk_session'

export const WELLBEING_LIMITS = {
	MAX_PER_WEEK: 3,
	MIN_GAP_MS: 60 * 60 * 1000,
	DISMISS_COOLDOWN_MS: 60 * 60 * 1000,
	COMPLETE_COOLDOWN_MS: 6 * 60 * 60 * 1000,
	IDLE_MS: 30 * 1000,
	RISK_DELAY_MS: 10 * 60 * 1000,
}

export const WELLBEING_SCENARIOS = {
	MIDDAY: 'midday',
	HEAVY: 'heavy',
	RISK: 'risk',
	EVENING: 'evening',
	MANUAL: 'manual',
	HELP: 'help',
}

export const BOX_BREATHING_PHASES = [
	{ id: 'inhale', label: 'INHALE', prompt: 'Breathe in slowly…', seconds: 4 },
	{ id: 'hold_in', label: 'HOLD', prompt: 'Hold gently…', seconds: 4 },
	{ id: 'exhale', label: 'EXHALE', prompt: 'Breathe out slowly…', seconds: 4 },
	{ id: 'hold_out', label: 'HOLD', prompt: 'Hold gently…', seconds: 4 },
]

export const WELLBEING_MESSAGES = {
	[WELLBEING_SCENARIOS.MIDDAY]: {
		body: [
			"You've been holding space for others all morning.",
			'Half the day has passed.',
			'One minute of breathing — just for you — before the afternoon begins.',
		],
	},
	[WELLBEING_SCENARIOS.HEAVY]: {
		body: [
			'You have been doing meaningful work today.',
			'Pause.',
			'Breathe.',
			'Continue when ready.',
		],
	},
	[WELLBEING_SCENARIOS.RISK]: {
		body: [
			'That was a difficult session.',
			'Take one minute before your next one.',
			'Before supporting someone else, take a moment for yourself.',
		],
	},
	[WELLBEING_SCENARIOS.EVENING]: {
		body: [
			'Finish what you need to today, then step away.',
			'Rest is part of the work.',
		],
	},
	[WELLBEING_SCENARIOS.MANUAL]: {
		body: [
			'One quiet minute, just for you.',
			'Breathe. Soften. Return when ready.',
		],
	},
	[WELLBEING_SCENARIOS.HELP]: {
		body: [
			'Counsellor self-care starts with one breath.',
			'This space is always here when you need it.',
		],
	},
}

export const WELLBEING_THEME = {
	primary: '#5B4BDB',
	primarySoft: '#EEF0FF',
	ring: '#C4B5FD',
	text: '#1E1B4B',
	muted: '#64748B',
	glass: 'rgba(255,255,255,0.88)',
	backdrop: 'rgba(100, 116, 139, 0.45)',
}
